/**
 * DNKADM-0475 (F-99): the alert a card sale shows on `409 ORDER_NEEDS_ATTENTION`
 * (DNKAPI-0690), shared by the sell cart, buy membership and walk-in dialogs.
 *
 * Nothing was charged by the refused request. The open order may already have charged the
 * card, so the alert names that order and sends staff to Payments instead of offering a
 * fresh charge. There is no override here: the open order is settled on Payments.
 */
import { Alert, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import type { OpenOrderNeedsAttention } from '@/api/membershipOrders';
import { memberPaymentsPath, orderNeedsAttentionMessage } from './orderNeedsAttention';

export function OrderNeedsAttentionAlert({
  openOrder,
  contactId,
  onLeave,
}: {
  openOrder: OpenOrderNeedsAttention;
  /** The dialog's own member, used when the refusal does not name one. */
  contactId: string | null;
  /** Closes the dialog before navigating away. */
  onLeave: () => void;
}) {
  const navigate = useNavigate();
  const path = memberPaymentsPath(openOrder.contactId ?? contactId);
  return (
    <Alert
      severity="warning"
      role="alert"
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            onLeave();
            navigate(path);
          }}
        >
          Check Payments
        </Button>
      }
    >
      {orderNeedsAttentionMessage(openOrder)}
    </Alert>
  );
}
